import angular from "angular";
import uiRouter from "@uirouter/angularjs";
import AppComponent from "./app.component";
import Components from "./components/components";
import Services from "./services/services";
import 'jquery/dist/jquery';
import 'bootstrap/dist/js/bootstrap';


angular.module('app', [
    uiRouter,
    Components.name,
    Services.name
  ])
  .config(($urlRouterProvider, $locationProvider) => {
    "ngInject";
    $locationProvider.html5Mode(true);
  })
  .controller("app", function ($scope, $rootScope) {

  })
  .run(($rootScope, $transitions, $window,  $location, $stateParams) => {
      "ngInject";
      $transitions.onSuccess({}, function ($transition) {
        $window.scrollTo(0,0);
        $window.ga('send', 'pageview', $location.path());
      });

      console.log($stateParams.jobId);


  })
  .component('app', AppComponent);



// WEBPACK FOOTER //
// ./app/app.js